import {
  Box,
  CircularProgress,
  DialogActions as MuiDialogActions,
  Paper,
  Typography,
} from '@mui/material';

import {
  CustomButton,
  DialogBody,
  DialogContainer,
  DialogTitle,
} from '../../../../common/components';
import { formatDateTime } from '../../utils/puntajeFormatters';

/**
 * Dialog que muestra el detalle de un contrato desde la tabla de movimientos de fondo.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Function} props.onClose
 * @param {Object|null} props.contractDetail - Datos del contrato devueltos por el backend.
 * @param {boolean} props.isLoading
 * @param {Object|null} props.error
 */
const ContractDetailDialog = ({ open, onClose, contractDetail, isLoading, error }) => (
  <DialogContainer open={open} onClose={onClose} size="small" minHeight="auto">
    <DialogTitle>Detalle del Contrato</DialogTitle>

    <DialogBody>
      {isLoading ? (
        <Box
          sx={{ minHeight: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <CircularProgress size={32} />
        </Box>
      ) : error ? (
        <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body1">No se pudo obtener el detalle del contrato.</Typography>
        </Paper>
      ) : !contractDetail ? (
        <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body1">Sin datos disponibles.</Typography>
        </Paper>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography variant="h6">Contrato {contractDetail.contract_number}</Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
            <Typography variant="body2">
              Fecha de suscripción:{' '}
              <strong>{formatDateTime(contractDetail.initial_subscription_date, false)}</strong>
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
            <Typography variant="body2">
              Plan: <strong>{contractDetail.plan_name || '-'}</strong>
            </Typography>
            <Typography variant="body2">
              Grupo: <strong>{contractDetail.group_name || '-'}</strong>
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2">
              Suscriptores:{' '}
              <strong>{contractDetail.subscriber_names?.join(', ') || '-'}</strong>
            </Typography>
          </Box>
        </Box>
      )}
    </DialogBody>

    <MuiDialogActions sx={{ px: 3, pb: 3 }}>
      <CustomButton variant="outlined" onClick={onClose}>
        Cerrar
      </CustomButton>
    </MuiDialogActions>
  </DialogContainer>
);

export default ContractDetailDialog;
